<div id="about" class="about-area ptb-100">
  <div class="container">
    <div class="section-title">
      <h2>{{ 'about.title' | translate }} <span>{{ 'about.highlight' | translate }}</span></h2> <!-- AZUL-->
      <p>{{ 'about.tagline' | translate }}</p>
    </div>
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12">
        <div class="about-content">
          <div class="section-title">
            <h2>{{ 'about.createTitle' | translate }} <span>{{ 'about.createHighlight' | translate }}</span></h2>
            <p>{{ 'about.intro' | translate }}</p>
          </div>
          <ul class="features-list">
            <li><i class="fas fa-check"></i>{{ 'about.sectors.software' | translate }}</li>
            <li><i class="fas fa-check"></i>{{ 'about.sectors.applied' | translate }}</li>
            <li><i class="fas fa-check"></i>{{ 'about.sectors.construction' | translate }}</li>
            <li><i class="fas fa-check"></i>{{ 'about.sectors.energy' | translate }}</li>
            <li><i class="fas fa-check"></i>{{ 'about.sectors.water' | translate }}</li>
            <li><i class="fas fa-check"></i>{{ 'about.sectors.lighting' | translate }}</li>
            <li><i class="fas fa-check"></i>{{ 'about.sectors.urbanism' | translate }}</li>
            <li><i class="fas fa-check"></i>{{ 'about.sectors.sport' | translate }}</li>
            <li><i class="fas fa-check"></i>{{ 'about.sectors.security' | translate }}</li>
          <li><i class="fas fa-check"></i>{{ 'about.sectors.urbanism' | translate }}</li>
        </ul>

        <p>{{ 'about.p1' | translate }}</p>
        <p>{{ 'about.p2' | translate }}</p>
      </div>
    </div>
    <div class="col-lg-6 col-md-12">
    @if (!isVideoPlaying) {
      <div class="about-video">
        <img src="assets/images/screenshot_v1_pafar.png" [attr.alt]="'about.videoAlt' | translate">
        <div class="video-btn">
          <button class="popup-youtube" (click)="playVideo()">
            <i class="fas fa-play"></i>
          </button>
        </div>
      </div>
    }
    @if (isVideoPlaying) {
      <div class="video-container" style="position: relative;">
        <button class="close-video-btn" (click)="closeVideo()">
          <i class="fas fa-times"></i>
        </button>
        <iframe
          [src]="videoUrl"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>
      </div>
    }
  </div>
</div>
</div>
</div>
